module.exports = __webpack_public_path__ + "assets/img/brigitte_bardot-83fd8952.jpg";